const getAvailability = (orderLineItem)=>{
    const availability = {
        channels: {}
    };
    const currentProduct = orderLineItem.product.currentProduct;
    if (currentProduct && currentProduct.availabilityChannels) {
        currentProduct.availabilityChannels.forEach((channel)=>{
            availability.channels[channel.id] = {
                isOnStock: channel.isOnStock,
                availableQuantity: channel.availableQuantity
            };
        });
    }
    return availability;
};

export { getAvailability };
//# sourceMappingURL=get-availability.js.map
